// Local imports

import * as libsgproduct from '../sgproduct/lib.js';
import * as design_handler from './design_handler.js';
// --------------------------------------------------------------------------
// Module vars
// --------------------------------------------------------------------------
// Module name
export const MODULE_NAME = 'memorial';
export let global_vars = {};
// --------------------------------------------------------------------------
// Functions
// --------------------------------------------------------------------------
export function main() {
    libsgproduct.main();
    design_handler.initialize(global);
}

